var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPostImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 8,
    fill: "#17468C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4996 10.9091C17.5431 10.9091 13.5107 14.9415 13.5107 19.8979C13.5107 24.8543 17.5431 28.8867 22.4996 28.8867C27.456 28.8867 31.4884 24.8543 31.4884 19.8979C31.4884 14.9415 27.456 10.9091 22.4996 10.9091Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6837 34.7591C31.2228 32.2603 27.9604 30.8842 24.4974 30.8842H20.5024C17.0395 30.8842 13.777 32.2603 11.3161 34.7591C8.86721 37.2456 7.51855 40.5278 7.51855 44.0012C7.51855 44.5528 7.96573 45 8.51731 45H36.4825C37.0341 45 37.4813 44.5528 37.4813 44.0012C37.4813 40.5278 36.1326 37.2456 33.6837 34.7591Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostImg);
export default __webpack_public_path__ + "static/media/post_img.2d0692aefffa99bde2dc3c35e43f6790.svg";
export { ForwardRef as ReactComponent };